import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, onMounted, watch } from 'vue'
import { GeoJSONSource, GeoJSONSourceSpecification } from 'mapbox-gl'
import { useMapBox } from './composables/useMapBox'
import { bbox } from '@turf/turf'
import { FeatureCollection } from 'geojson'

export interface Props {
	id: string
	spec: GeoJSONSourceSpecification
	initFitBounds?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBoxSource',
  props: {
    id: null,
    spec: null,
    initFitBounds: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { id: string, spec: GeoJSONSourceSpecification, initFitBounds: boolean };



const { map } = useMapBox()

onMounted(() => {
	if (!map?.value) throw new Error('mapbox map instance not found')
	map.value.addSource(props.id, props.spec)
})

function fitBounds(geojson: FeatureCollection) {
	if (!map?.value || !props.initFitBounds) return

	// Coleção vazia (ex.: fazendas ainda não carregadas ou nenhuma selecionada) gera
	// bbox [Infinity, Infinity, -Infinity, -Infinity], e o fitBounds lança
	// "Invalid LngLat latitude value". Sem área válida não há o que enquadrar.
	const bounds = bbox(geojson)
	const [, minLat, , maxLat] = bounds
	if (!bounds.every(Number.isFinite) || minLat < -90 || maxLat > 90) return

	map.value.fitBounds(bounds as any, {
		padding: 20,
		maxZoom: 13,
	})
}

function removeLayers() {
	if (!map?.value) return

	const style = map.value.style

	if (!style) return

	const layers = style._layers

	if (!layers) return

	const sourceLayers = Object.values(layers).filter((layer) => layer.source === props.id)

	if (sourceLayers) sourceLayers.forEach((layer) => map?.value?.removeLayer(layer.id))
}

function updateDataSource(data: any, refit: boolean) {
	if (!map?.value) throw new Error('mapbox map instance not found')
	map.value.getSource<GeoJSONSource>(props.id)?.setData(data)
	if (refit) fitBounds(data)
}

function removeSource() {
	if (!map?.value) return
	removeLayers()
	map.value.removeSource(props.id)
}

watch(
	() => props.spec.data,
	// Pais costumam passar :spec="{ ... }" inline: qualquer re-render do pai cria um
	// spec novo e dispara este watcher (deep) com o MESMO data. Reenquadrar nesse caso
	// desfazia o zoom do usuário (ex.: ao abrir o tooltip de um foco de incêndio), então
	// o fitBounds só roda quando o data muda de fato.
	(value, oldValue) => updateDataSource(value, value !== oldValue),
	{ immediate: true, deep: true },
)

onUnmounted(() => removeSource())

return { __sfc: true,props, map, fitBounds, removeLayers, updateDataSource, removeSource }
}

})